/*
home
deck
spot
の4つの階層に分けて、それぞれの処理をそれぞれのjsで行う
loadingが必要なのは
spot > spotの時
*/
let homeNum = 4,
	folderNum = homeNum + 1,
	subpageNum = homeNum + 2;
var fw = {
	isFirst: true,
	currentPage: "",
	prevPage: "",
	checkURL: function(){
		$("#btn_back").addClass("disable");
		let $body 	= $("body");
		let arg 	= new Object,
			prop 	= location.pathname,
			arry 	= prop.split("/"),
			len 	= arry.length;

		page.param 	= location.search.substring(1);
		page.lang 	= arry[2];
		page.folder = arry[3];
		page.currentURL = arry;

		//console.log(arry[arry.length-2])
		page.currentParam();
		console.log("check URL > 言語:",page.lang, arry , "パラメータ:", page.param, "folder:", page.folder, arry.length);
		fw.checkNav();
		
		if(arry.length === folderNum){
			if(page.folder === "deck"){
				cardview.jsonName = arry[arry.length-1].replace(".html", "");
			}
		}
		//console.log(subpageNum, arry.length, page.folder);
		if(fw.isFirst){
			fw.prevPage = page.folder;
			if(arry.length === homeNum){
				let lastName = arry[arry.length-1];
				if(lastName === "spot"){
					page.folder = lastName;
				}else if(lastName === "deck"){
					page.folder = lastName;
				}else if(lastName === "about"){
					page.folder = lastName;
				}else{
					page.folder = "home";
					home.init();
				}
			}else if(arry.length === folderNum){
				if(page.type === "spot"){
					page.folder = "spot";
				}else if(page.type === "deck"){
					page.folder = "deck";
				}
			}
			fw.changeTopBlock();
			fw.afterChangePage();
		}else{
			//2回目以降
			if(arry.length === homeNum){
				//TOP ABOUT 検索
				let lastName = arry[arry.length-1];
				if(lastName === "spot"){
					page.folder = lastName;
					spot.hideSpotDetail();
				}else if(lastName === "deck"){
					page.folder = lastName;
					spot.hideSpotDetail();
				}else if(lastName === "about"){
					page.folder 	= lastName;
					page.searchCat 	= "";
				}else{
					page.folder = "home";
					page.searchCat = "";
					spot.hideSpotDetail();
				}
				fw.changeTopBlock();
				fw.afterChangePage();
			}else if(arry.length === folderNum){
				//検索結果ページ
				if(page.type === "spot"){
					page.folder = "spot";
				}else if(page.type === "deck"){
					page.folder = "deck";
					fw.changeTopBlock();
				}
				
				//詳細ページ
				if(page.folder === "spot"){
					if( $body.hasClass("is_cardview") ){
						//deck > spot
						console.log("%cdeck detail > spot detail", 'color: #f44cff');
						common.showLoading().done(function(){
							fw.changeTopBlock();
						});
					}else if( $body.hasClass("is_spot_detail") ){
						if(page.type === "spot"){
							if(is_detail_to_sort){
								loadPage.load();
							}else{
								//検索詳細に戻る
								spot.hideSpotDetail();
								setTimeout(function(){
									fw.changeTopBlock();
								}, 400);
							}
							
						}else{
							//spot > spot
							//console.log("%cspot detail > spot detail", 'color: #f44cff');
							common.showLoading().done(function(){
								fw.changeTopBlock();
							});
						}
					}else{
						fw.changeTopBlock();
					}
				}else if(page.folder === "deck"){
					if(page.type === "deck"){
						if( $body.hasClass("is_cardview") ){
							//console.log("%cdeck detail>  deck search", 'color: #f44cff');
							$("#search_layer_deck").addClass("show");
							cardview.hide();
						}
					}else{
						if( $body.hasClass("is_spot_detail") ){
							$("#spot").addClass("disable");
							setTimeout(function(){
								spot.hideSpotDetail();
								fw.changeTopBlock();
							},400);
						}else{
							if( $("body").hasClass("page_home") ){
								fw.changeTopBlock();
							}else{
								$("#deck_cardview").addClass("disable");
								//デッキ詳細
								spot.hideSpotDetail();
								fw.changeTopBlock();
							}
						}
					}
				}
			}else{
				spot.hideSpotDetail();
				fw.changeTopBlock();
			}
		}
		
	},
	changeURL: function(path){
		//ページ切り替えの際に必ず通る
		$html.classList.add("disable_nav");
		
		hstry.changeBeforeHistory();
		window.history.pushState(null, null, path);
		//コピー用のURL
		$("input.share_url").val(location.href);
		fw.checkURL();
	},
	changeTopBlock: function(){
		//ページ切り替えの際に必ず通る
		//console.log("%cChange Top Block", 'color: pink');
		let $body 			= $("body"),
			$searchLayer 	= $("#search_layer");
		let currentPage  	= $("body").attr("class");
		if(page.folder === "about"){
			$body.addClass("page_" + page.folder);
			common.sendPageView(page.folder, location.pathname + location.search);
			setTimeout(function(){
				$("body").addClass("scroll_about");
				fw.afterChangePage();
			},600);
		}else{
			//htmlについているis_系クラスをトルツメ
			$("html").removeClass(function(index, className) {
				return (className.match(/\bis_\S+/g) || []).join(' ');
			});
			//メインのページ切り替え
			$body.removeClass(function(index, className) {
				return (className.match(/\bpage_\S+/g) || []).join(' ');
			});
			$body.addClass("page_" + page.folder);
			
			if(page.folder != "about"){
				$("body").removeClass("scroll_about");
				$("body").removeClass("scroll_deck");
			}

			if(page.currentURL.length === homeNum){
				//window.scrollTo(0,0);
				if(page.folder === "spot"){
					if(page.param != ""){
						//spot検索
						//検索結果が出ていたら消す
						window.scrollTo(0,0);
						spSearch.hideResult();
						cardview.hide();
						fw.afterChangePage();
					}
				}else if(page.folder === "deck"){
					if(page.param != ""){ //deck検索選択画面
						
						window.scrollTo(0,0);
						spSearch.hideResult();
						cardview.hide();
						$("body").removeClass("scroll_deck");
						//fw.afterChangePage();
					}
				}else{
					window.scrollTo(0,0);
					//検索結果が出ていたら消す
					spSearch.hideResult();
					cardview.hide();
				}
			}else if(page.currentURL.length === folderNum){
				//検索結果が出ていたら消す
				if(page.folder === "spot"){
					if(page.type === "spot"){
						//検索結果
						if( !$("#search_layer_spot").hasClass("show") ){
							//スポット検索結果が出てなかったらロードする
							//スポット詳細から戻る時はロードしない
							loadPage.load();
						}else{
							fw.afterChangePage();
						}
					}else{
						/*スポット詳細
						CARDVIEWが下にある可能性アリ
						-------------------------- */
						spot.init();
					}
				}else if(page.folder === "deck"){
					if(page.param === ""){
						//デッキカードビューページ
						if(currentPage.indexOf("page_home") ){
							//home > デッキ詳細
							cardview.init();
						}else{
							cardview.init();
						}
					}else if(page.param === "map"){
						cardview.init();
					}else if(page.type === "deck"){
						//検索結果
						if( !$("#search_layer_deck").hasClass("show") ){
							loadPage.load();
						}else{
							fw.afterChangePage();
						}
					}
				}
			}else{
				//検索結果が出ていたら消す
				spSearch.hideResult();
				cardview.hide();
			}
		}
	},
	beforeCloseLoading: function(){
		let urlLen = page.currentURL.length;

		if(urlLen === folderNum){
		}else if(urlLen === subpageNum){
			//検索系
			if(page.folder === "spot"){
				spSearch.showSpotResultPage();
			}else if(page.folder === "deck"){
				spSearch.showDeckResultPage();
			}
		}
	},
	afterChangePage: function(){
		//console.trace("afterchange")
		fw.prevPage = page.folder;
		let urlLen = page.currentURL.length,
		$spot = $("#spot");
		is_detail_to_sort = false;
		common.resize();
		common.nav();
		loadPage.overrideTitle();

		//スポットから来た人用のclassを削除
		if( $spot.hasClass("first") ){
			$spot.removeClass("first");
		}
		if(page.folder != "about"){
			$("body").removeClass("scroll_about");
		}
		if(page.folder === "about"){
			//common.sendPageView(page.folder, location.pathname + location.search);
		}else{
			if(urlLen === folderNum){
				if(page.folder === "spot" || page.folder === "deck"){
					if(page.type === "spot"){
						if( !$("body").hasClass("scroll_spot") ){
							spSearch.showSpotResultPage();
							$("#search_layer_spot").removeClass("disable");
						}
					}else if(page.type === "deck"){
						if( !$("body").hasClass("scroll_deck") ){
							spSearch.showDeckResultPage();
							if($("#search_layer_deck").hasClass("disable")){
								$("#search_layer_deck").removeClass("disable");
							}
						}
						if(!loadPage.isLoadMore){
							spot.hideSpotDetail();
						}
					}else{
						//スポット詳細
						if(page.folder === "spot"){
							//DECK > SPOTに来た場合
							cardview.hide();
							common.sendPageView(page.folder, location.pathname + location.search);
						}else if(page.folder === "deck"){
							if( !$body.hasClass("scroll_deck") ){
								$body.addClass("scroll_deck");
							}
							if(page.param === "map"){
								//common.sendPageView("deck_map", location.pathname);
							}else{
								common.sendPageView(page.folder, location.pathname + location.search);
							}
						}
					}
				}
			}else{
				if(page.folder === "spot"){

				}else if(page.folder === "deck"){
					
				}else{
					common.sendPageView(page.folder, location.pathname + location.search);
				}
				homeSlide.init();
				cardview.hide();
				spot.hideSpotDetail();
			}
		}
		
		hstry.add();
		if(fw.isFirst){
			fw.isFirst = false;
		}
		$("#btn_back").removeClass("disable");
		$html.classList.remove("disable_nav");
		console.log("%cfw.after Change Page-----------------------------------------", 'color: pink');
	},
	checkNav: function(){
		//console.log("check nav --------------------------------");
		let thisNav = "";
		if(page.folder === ""){
			thisNav = "home";
		}else{
			thisNav = page.folder;
		}
		if(page.currentURL.length === 5){
			if(page.type === "spot"){
				thisNav = "spot";
			}else if(page.type === "deck"){
				thisNav = "deck";
			}
		}
		$("#glbnav a").removeClass("active");
		$('#glbnav a[data-name="' + thisNav + '"]').addClass("active");
	},
	checkHeader: function(){
		//console.log("checkHEADER --------------------------------");
		let $header = $("header#glb_header");
		$header.removeClass(function(index, className) {
			return (className.match(/\bis_\S+/g) || []).join(' ');
		});
		$header.removeClass(function(index, className) {
			return (className.match(/\bshow_\S+/g) || []).join(' ');
		});

		//検索ナビを表示
		//console.log(page.currentURL.length, homeNum, page.folder, page.param)
		let len = page.currentURL.length;

		if(len === homeNum){
			$header.removeClass("is_deckdetail");
			$header.removeClass("is_spotdetail");
			if(page.folder === "spot"){
				if(page.param != ""){
					//spot検索
				}
			}else if(page.folder === "deck"){
				
			}else if(page.folder === "about"){
			}else{
				$header.addClass("is_home");
			}
		}else if(len === folderNum){
			if(page.folder === "spot"){
				$header.removeClass("is_deckdetail");
				if(page.type === "spot"){
					$header.removeClass("is_spotdetail");
				}else{
					$header.addClass("is_spotdetail");
				}
			}else if(page.folder === "deck"){
				$header.removeClass("is_spotdetail");
				if(page.type === "deck"){
					$header.removeClass("is_deckdetail");
				}else{
					$header.addClass("is_deckdetail");
				}
			}
		}
		//is_deckdetail
		if(page.currentURL.length === homeNum && page.param != ""){
			if(page.folder === "spot" || page.folder == "deck"){
				if(page.param === "map"){
					if( $header.hasClass("show_search_nav") ){
						$header.removeClass("show_search_nav");
					}
				}else{
					if( !$header.hasClass("show_search_nav") ){
						$header.addClass("show_search_nav");
					}
				}
			}
		}else{
			if( $header.hasClass("show_search_nav") ){
				$header.removeClass("show_search_nav");
			}
		}
		$header.addClass("is_" + page.folder);
		
		//debug----------------------------------------------
		let kaisou = page.urlLength();
		$("#c_page").html( page.folder );
		$("#c_kaisou").html( page.urlLength() );
		$("#c_search_cat").html( page.searchCat );
		$("#c_prop").html( page.param );
		if(page.param != ""){
			$("#c_hasp").html("あり")
		}else{
			$("#c_hasp").html("なし")
		}
	},
	checkSearchNav: function(){
		$("#nav_search li a").removeClass("active");
		$('[data-name="' + page.searchCat + '"]').addClass("active");

		//検索ブロックの切り替え
		if(page.folder === "spot"){
			$("#search_spot #search_spot_types").removeClass();
			$("#search_spot #search_spot_types").addClass("active_" + page.searchCat);
		}else if(page.folder === "deck"){
			$("#search_deck #search_deck_types").removeClass();
			$("#search_deck #search_deck_types").addClass("active_" + page.searchCat);
		}
	}
}